exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "users-list .media{position:relative;padding:6px;background-color:#f9f9f9}users-list .media:first-child{margin-top:-3px}users-list .media:hover{background-color:#f9f9f9}users-list .media .media-body{display:flex;width:100%}users-list .media .media-body>div{flex:1 1 50%}users-list .media .media-body h4{margin-bottom:0;font-size:16px;font-weight:700}users-list .media .media-right{position:absolute;right:11px;top:11px;float:right}users-list .media .media-right a{display:inline-block;border:1px solid #ccc;color:#000}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/admin/users/users-list/users-list.styl
 ** module id = 404
 ** module chunks = 0
 **/